import CookieService from '~/services/cookies'
import { TranslationService } from '~/services/Translation'
import authMiddleware from '~/middleware/auth'
import { TripNavigation } from '~/services/navigation/trip'

export default defineNuxtRouteMiddleware((to, from) => {
	if (import.meta.server) return
	if (to.query.createTrip !== 'true') return

	const authCookie = CookieService.getCookie('authentication-cookie')
	if (!authCookie) return authMiddleware(to, from)

	const nuxtApp = useNuxtApp()
	TranslationService.getInstance(nuxtApp.$i18n)
	if (to.query.createTrip === 'true') {
		const unsubscribeHook = nuxtApp.hook('page:finish', () => {
			nextTick(() => {
				TripNavigation.toCreateTrip()
				unsubscribeHook()
			})
		})
	}
})
